import { MarketplaceComponentConfig } from '@nocode/types';

const config: MarketplaceComponentConfig = {
  displayName: {
    en: 'Chat',
    ja: 'チャット',
  },
  name: 'ChatComponent',
  resizeX: true,
  resizeY: true,
  props: [
    {
      name: 'chatSetting',
      type: 'string',
      displayName: {
        en: 'Chat setting',
        ja: 'Chat setting',
      },
      default: {
        usernameField: {
          fid: 'username',
        },
      },
    },
    {
      // MIK-4828: replaces the old `supportUploadFile` boolean. Rendered by
      // ChatUploadFileSetting in the editor (see PropControl); elements saved
      // before this still carry `supportUploadFile` and are read as a fallback
      // in utils.getUploadFileMode.
      name: 'uploadFileSetting',
      type: 'string',
      displayName: {
        en: 'File attachment',
        ja: 'ファイル添付',
      },
      // Deliberately no `default`: PropControl substitutes prop.default whenever
      // the attribute is absent, which would show "always" for a legacy element
      // whose `supportUploadFile` is false. Leaving it unset lets the editor
      // control derive the mode from the legacy value, matching the runtime.
    },
    {
      // MIK-5038: the mobile picker crops every photo to an 800x800 square.
      // "Unable" uploads the photo as shot, for apps that need the original.
      // Only affects iOS/Android -- the web picker has always uploaded the
      // chosen file untouched. See utils.getChatImagePickerOptions.
      name: 'imageCompress',
      type: 'boolean',
      displayName: {
        en: 'Image compress',
        ja: '画像の圧縮',
      },
      default: true,
      control: {
        type: 'menu',
        options: [
          {
            label: 'Enable',
            value: true,
          },
          {
            label: 'Unable',
            value: false,
          },
        ],
      },
    },
    {
      name: 'value',
      type: 'string',
      role: 'formValue',
      displayName: 'New Message',
    },
    {
      name: 'action',
      type: 'action',
      displayName: {
        en: 'On Message sent',
        ja: 'メッセージ送信時',
      },
    },
    // constrain layout
    {
      name: 'constrainLayout',
      type: 'constrainLayout',
      displayName: {
        en: 'Constrain Layout',
        ja: 'Constrain Layout',
      },
    },
  ],
  childComponents: [
    {
      displayName: {
        en: 'Push notification after send message',
        ja: 'メッセージ送信時のPush通知',
      },
      name: 'sendNotification',
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'title',
          type: 'text',
          displayName: {
            en: 'Title',
            ja: 'タイトル',
          },
        },
      ],
    },
  ],
};

export default config;
